import React, { useEffect, useState, useCallback } from "react";
import MasterTable from "../../../src/views/dashboard/widget/MasterTabel";
import { useNavigate } from "react-router-dom";
import AddUserForm from "../../components/FormComponents/AddUserForm.js"; // For navigation
import "../../../src/assets/css/table.css";
import {
  getUserList,
  deleteUser,
  updateStatus,
} from "../../services/Users-services.js";
import { filterStorageUtils } from "../../services/filterStorageUtils.js";

const UsersTable = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [_advanceFilterList, setAdvanceFilterList] = useState(
    filterStorageUtils.getFilterList()
  );

  // Update filter list and sync with localStorage
  const updateAdvanceFilterList = useCallback((updater) => {
    setAdvanceFilterList((prevList) => {
      const newList =
        typeof updater === "function" ? updater(prevList) : updater;
      filterStorageUtils.setFilterList(newList);
      return newList;
    });
  }, []);

  // Reset filter data
  const resetAdvanceFilterData = useCallback(() => {
    const defaultData = filterStorageUtils.resetFilterData();
    return defaultData;
  }, []);

  // Listen for filter changes from other components
  useEffect(() => {
    const unsubscribe = filterStorageUtils.subscribeToFilterChanges(() => {
      setAdvanceFilterList(filterStorageUtils.getFilterList());
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    // Set up the filter list for Users table
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });

    setIsInitialized(true);

    // Cleanup function - reset filters when component unmounts
    return () => {
      console.log("UsersTable: Cleaning up filters on unmount");
    };
  }, [updateAdvanceFilterList]);

  return !isInitialized ? (
    <div>Loading...</div>
  ) : (
    <MasterTable
      getTableData={getUserList}
      deleteRow={deleteUser}
      updateStatus={updateStatus}
      tab1={"User Management"}
      tab2={"Users"}
      actions={{
        status: true,
        edit: true,
        delete: true,
      }}
      // isStudentPortal={true}
      AddForm={AddUserForm}
    />
  );
};

export default UsersTable;
